import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { Button } from "@components/ui/button";

const OPTIONS = [
  { label: "Data List", value: "datalist" },
  { label: "Threat Lookup", value: "threatlookup" },
];
const PLACEHOLDER_VALUE = "choose_option";

interface OtherLogicTypeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  otherType: string | null;
  setOtherType: (value: string | null) => void;
  onContinue: (type: string) => void;
  disabledTypes: string[];
}
const OtherLogicTypeDialog = ({
  open,
  onOpenChange,
  otherType,
  setOtherType,
  onContinue,
  disabledTypes,
}: OtherLogicTypeDialogProps) => {
  React.useEffect(() => {
    if (open) {
      setOtherType(null);
    }
  }, [open, setOtherType]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>Select Type</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <label className="text-sm font-medium">Choose option</label>
          <Select
            value={otherType ?? PLACEHOLDER_VALUE}
            onValueChange={(value) => {
              if (value === PLACEHOLDER_VALUE) {
                setOtherType(null);
                return;
              }
              setOtherType(value);
            }}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>

            <SelectContent>
              {/* Placeholder item — selected initially */}
              <SelectItem value={PLACEHOLDER_VALUE}>Choose option</SelectItem>

              {OPTIONS.map((opt) => {
                const isDisabled = disabledTypes.includes(
                  opt.label.toLowerCase(),
                );

                return (
                  <SelectItem
                    key={opt.value}
                    value={opt.value}
                    disabled={isDisabled}
                  >
                    {opt.label}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setOtherType(null);
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>

          <Button
            disabled={!otherType}
            onClick={() => {
              if (!otherType) return;
              onContinue(otherType);
              onOpenChange(false);
            }}
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OtherLogicTypeDialog;
